import { BaseRowNumberModelInterface, DomainModelRowNumberCollectionInterface, IdentityInterface } from '@nts/std/interfaces';
import { DomainModelCollection } from './domain-model-collection';


export abstract class DomainModelRowNumberCollection<TItem extends BaseRowNumberModelInterface<TIdentity>, TIdentity extends IdentityInterface>
    extends DomainModelCollection<TItem, TIdentity> implements DomainModelRowNumberCollectionInterface<TIdentity, TItem> {

}
